import { render, staticRenderFns } from "./dict-item-dialog.vue?vue&type=template&id=b8bfcf9e&"
import script from "./dict-item-dialog.vue?vue&type=script&lang=js&"
export * from "./dict-item-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports